import React, { useRef, useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { defaultAreaId, reportingYear } from "../../../constants";
import { formatValue } from "../../../utilities";
import AreaChooser from "../../choosers/AreaChooser";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import MethodMixOfUseVsCostChart from "./MethodMixOfUseVsCostChart";
import SectorChooser from "../../choosers/SectorChooser";

const MethodMixOfUseVsCostBySectorChartWidget = props => {
  const [sectorId, setSectorId] = useState(6);
  const [areaId, setAreaId] = useState(defaultAreaId);

  const ref = useRef();

  return (
    <DataViewerFrame
      dataViewerId="method_mix_of_use_vs_cost_by_sector_chart"
      reference="Figure 4.4"
      title={`Method Mix of Use versus Cost, ${reportingYear}`}
      subtitle={sectorId && `Within ${props.database.sectors[sectorId]} Sector`}
      contentWidth={300}
      filters={[
        <SectorChooser
          id="figure-4-4-sector"
          sectorIds={new Set([3, 6])}
          selectedKey={sectorId}
          onChange={sectorId => {
            setSectorId(sectorId);

            props.onChange({
              widget: "theme4.methodMixOfUseVsCostBySectorChart",
              payload: {
                areaId,
                sectorId
              }
            });
          }}
        />,
        <AreaChooser
          id="figure-4-4-area"
          label="Select Country or Country Group"
          areas={props.database.areas}
          includeCountries={true}
          selectedKey={areaId}
          onChange={areaId => {
            setAreaId(areaId);

            props.onChange({
              widget: "theme4.methodMixOfUseVsCostBySectorChart",
              payload: {
                areaId,
                sectorId
              }
            });
          }}
        />
      ]}
      chartRef={ref}
      chartSettings={{
        sector: sectorId ? props.database.sectors[sectorId] : "All",
        area: props.database.areas[areaId].area
      }}
    >
      <MethodMixOfUseVsCostChart
        ref={ref}
        data={props.data}
        tooltipFormatter={function() {
          return `${this.series.name} Share of ${
            this.key
          } Mix: <strong>${formatValue(
            Math.abs(this.percentage) / 100,
            true
          )}</strong>`;
        }}
      />
    </DataViewerFrame>
  );
};

MethodMixOfUseVsCostBySectorChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default MethodMixOfUseVsCostBySectorChartWidget;
